import { withAuthenticator } from 'aws-amplify-react-extended';
import AmplifyTheme from '../themes/Amplify-UI';

const signUpConfig = {
  hideAllDefaults: true,
  signUpFields: [
    {
      label: 'Email',
      key: 'email',
      placeholder: 'Email',
      required: true,
      type: 'email',
      displayOrder: 1,
    },
    {
      label: 'Choose a Username',
      key: 'preferred_username',
      required: true,
      placeholder: 'Username',
      inputProps: {
        maxLength: '8',
      },
      helperText: 'Not Your Real Name! Maximum 8 characters',
      displayOrder: 2,
    },
    {
      label: 'Password',
      key: 'password',
      required: true,
      placeholder: 'Password',
      type: 'password',
      helperText: 'Passwords must be a minimum 10 characters in length',
      displayOrder: 3,
    },
  ],
};

const withAuth = (component) => (
  withAuthenticator(
    component,
    false, [],
    null,
    AmplifyTheme,
    signUpConfig,
    'email',
    'material',
    true,
  )
);

export default withAuth;
